import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import * as marietta from '../../../';
import { MasterItemCollection } from '../../../webcad/collection';
import { MonicaObject } from '../../../webcad/item';

export class ChangePointCeiling {

    constructor(private ceiling: THREE.Object3D) {
    }

    public setMaterial(index: number) {
        this.setTexture(ThreeView.get().matmgr.me.materials().clothTexes[index]);
    }

    public setMaterialByName(name: string) {
        this.setTexture(ThreeView.get().matmgr.me.materials().clothTexes.find((texture) => {
            return name == texture.name;
        }));
    }

    private setTexture(texture: THREE.Texture) {
        if (!texture) return;
        const mesh = <THREE.Mesh>this.ceiling;
        if (!mesh.isMesh) return;
        if (Array.isArray(mesh.material)) {
            ;
        } else {
            const material = <THREE.MeshStandardMaterial>mesh.material.clone();
            material.map = texture;
            mesh.material = material;

            marietta.webcad.WebCADGlobal.itemManager.updateCeilingMaterial(this.ceiling.userData.guid, texture.name);
        }
    }

    public setToEndItem( info) {
        marietta.webcad.WebCADGlobal.itemManager.updateCeilingEndItem(this.ceiling.userData.guid, info );
    }
    public getEndItem():MasterItemCollection {
        return marietta.webcad.WebCADGlobal.itemManager.getCeilingEndItem(this.ceiling.userData.guid );
    }
    public get2D():MonicaObject{
        return marietta.webcad.WebCADGlobal.itemManager.getCeilingParentItem( this.ceiling.userData.guid );
    }

    public getTargetGuid():string{
        return this.ceiling.userData.guid;
    }

}
